<app-side-controls [pariclesComponent]="particlesComponent" />
<app-side-controls-mobile />
<app-particles #particlesComponent />
<app-sidebar #sidebarComponent [instancesComponent]="instancesComponent" />
<app-instances
  #instancesComponent
  [pinwheelComponent]="pinwheelComponent"
  [sidebarComponent]="sidebarComponent"
/>
<app-pinwheel #pinwheelComponent />
<app-logo />
<app-reset />
